import React from 'react'
import Footer from '../component/Footer'
import Hero from '../component/Hero'
import Navbar from '../component/Navbar'
import Project from '../component/Project'
import Technology from '../component/Technology'

const TechRoute = () => {
  return (
    <>
    <Navbar/>
    <Hero/>
    <Technology/>
    <Footer/>
    </>
  )
}

export default TechRoute